const runConfig =
  typeof window !== 'undefined'
    ? window.runConfig || window['runConfig']
    : undefined;

if (!runConfig) {
  console.error(
    'window.runConfig is missing. Copy public/runtime-config.js and reload.'
  );
}

const {
  api_base_url = '',
  chat_base_url = '',
  chat_protocol = 'wss://',
  user_mgmt_url = '',
  file_uploads_url = '',
} = runConfig || {};

export const CONFIG = {
  api_base_url,
  chat_base_url,
  chat_protocol,
  user_mgmt_url,
  file_uploads_url,
};
